StatementsManager.HANDLERS.ActionCreated = StatementHandler.extend({

	initialize: function(params) {
		StatementHandler.prototype.initialize.call(this, params);

		this.skillsManager = this.container.getComponent("SkillsManager");
		this.actionsManager = this.container.getComponent("ActionsManager");
	},

	handleBlockInitialized: function(e) {
		StatementHandler.prototype.handleBlockInitialized.call(this, e);

		var block = e.blockData.view;
		if(block instanceof ActionPlan) {
			this.listenTo(block, "onActionPlanFinished", this.handleOnActionPlanFinished);
		}
	},

	handleOnActionPlanFinished: function(e) {
        _.each(this.actionsManager.getActions(), function(action) {
			var period = action.getLimit();
			var verb = action.getVerb();
			var skillId = action.getSkillId();

			var item = {
				actionId: encodeURI(this.agent.id + action.getId()),
				actionTitle: action.getTitle(),
				period: period != null ? period : "",
				verb: verb != null ? verb : "",
				actionText: action.getNoun(),
				notes: action.getCustom().trim()
			};

			var skill = this.skillsManager.getSkill(skillId);
			if(skill) item.skillTitleURI = encodeURI(skill.getSkillId()); // different to action.skillId
			this.addDataItem(item);
		}, this);

		this.ready();
	},

	substituteData: function(data) {
        var statement = StatementHandler.prototype.substituteData.call(this, data);

        if(!("skillTitleURI" in data)) delete statement.context.contextActivities; // remove contextActivities if no skill

        return statement;
    },
});
